// src/styles/GlobalStyles.js
import { createGlobalStyle } from 'styled-components';
import theme from './Theme';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&family=Open+Sans:wght@300;400;500;600;700&family=Roboto+Mono&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${theme.fonts.main};
    background-color: ${theme.colors.background};
    color: ${theme.colors.textMain};
    overflow-x: hidden;
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.heading};
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1rem;
    color: ${theme.colors.primary};
  }

  h1 {
    font-size: ${theme.fontSizes.xxxl};
    
    @media (max-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.fontSizes.xxl};
    }
  }

  h2 {
    font-size: ${theme.fontSizes.xxl};
    position: relative;
    
    &:after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 0;
      width: 60px;
      height: 3px;
      background-color: ${theme.colors.primary};
    }
    
    @media (max-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.fontSizes.xl};
    }
  }

  h3 {
    font-size: ${theme.fontSizes.xl};
  }

  p {
    margin-bottom: 1rem;
    font-size: ${theme.fontSizes.medium};
    color: ${theme.colors.textMain};
  }

  a {
    text-decoration: none;
    color: ${theme.colors.primary};
    transition: color ${theme.transitions.fast};
    
    &:hover {
      color: ${theme.colors.primaryDark};
    }
  }

  ul, ol {
    margin-left: 2rem;
    margin-bottom: 1rem;
  }

  button, .button {
    cursor: pointer;
    font-family: ${theme.fonts.main};
    font-size: ${theme.fontSizes.medium};
    font-weight: 600;
    padding: 0.75rem 1.5rem;
    border-radius: ${theme.borderRadius.medium};
    border: none;
    transition: all ${theme.transitions.fast};
    
    &.primary {
      background-color: ${theme.colors.primary};
      color: ${theme.colors.light};
      
      &:hover {
        background-color: ${theme.colors.primaryDark};
      }
    }
    
    &.secondary {
      background-color: transparent;
      border: 2px solid ${theme.colors.primary};
      color: ${theme.colors.primary};
      
      &:hover {
        background-color: ${theme.colors.primary};
        color: ${theme.colors.light};
      }
    }
  }

  section {
    padding: 5rem 0;
    
    @media (max-width: ${theme.breakpoints.sm}) {
      padding: 3rem 0;
    }
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${theme.spacing.md};
    
    @media (max-width: ${theme.breakpoints.sm}) {
      padding: 0 ${theme.spacing.sm};
    }
  }
  
  .text-center {
    text-align: center;
    
    h2:after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
  
  .card {
    background-color: ${theme.colors.light};
    border-radius: ${theme.borderRadius.medium};
    overflow: hidden;
    box-shadow: ${theme.shadows.small};
    transition: box-shadow ${theme.transitions.fast}, transform ${theme.transitions.fast};
    
    &:hover {
      box-shadow: ${theme.shadows.medium};
      transform: translateY(-5px);
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }
  
  .grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: ${theme.spacing.md};
    
    @media (max-width: ${theme.breakpoints.sm}) {
      gap: ${theme.spacing.sm};
    }
  }
`;

export default GlobalStyles;